import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withRouterConfig,
} from '@angular/router';
import { provideSentry, provideUnleash } from '@thiememeulenhoff/ng-sdk';
import { provideApiGateway } from '@thiememeulenhoff/ng-api-gateway';
import { SecurityModule } from '@thiememeulenhoff/ng-security';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideSentry,
    provideUnleash(environment.unleash),
    provideApiGateway({
      environment: environment.environment,
    }),
    provideRouter(
      appRoutes,
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
    ),
    importProvidersFrom(
      SecurityModule.forRoot({
        environment: environment.auth.environment,
        clientId: environment.auth.clientId,
        clientSecret: environment.auth.clientSecret,
      }),
    ),
  ],
};
